import axios from "axios";
import { getCookie } from "../getcookie";

const apiUrl = process.env.REACT_APP_API_URL;

// Helper function to get headers with fresh token
const getHeaders = () => ({
  "Content-Type": "application/json; charset=UTF-8",
  Accept: "application/json",
  "Access-Control-Allow-Origin": "*",
  Authorization: getCookie("mawalog"),
});

// Helper function for API calls
export const apiCall = async (method, endpoint, data = null, options = {}) => {
  try {
    const config = {
      method,
      url: `${apiUrl}${endpoint}`,
      headers: getHeaders(),
      ...options,
    };

    if (data) {
      config.data = data;
    }

    const response = await axios(config);
    return response;
  } catch (error) {
    console.error(`Error in ${method} ${endpoint}:`, error);
    return (
      error.response || { data: { success: false, message: error.message } }
    );
  }
};
